import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { noWhitespaceValidator } from 'src/app/common-components/validators/no-whitespace.validator';
import { Dashboard } from '../../models/dashboard.model';
import { getDashboards } from '../../state/dashboard.selectors';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-add-dashboard-dialog',
    templateUrl: './add-dashboard-dialog.component.html',
    styleUrls: ['./add-dashboard-dialog.component.scss'],
    standalone: false
})
export class AddDashboardDialogComponent implements OnDestroy {
   @Output() submit = new EventEmitter<UntypedFormGroup>();

   @Output() close = new EventEmitter<UntypedFormGroup>();

   form: UntypedFormGroup;

   private baseName = 'My Dashboard';

   private destroyed$ = new Subject<void>();

   constructor(private fb: UntypedFormBuilder, private store: Store, private dialogService: LcsDialogService) {
      this.store.select(getDashboards).subscribe((d: Dashboard[] | null) => {
         this.form = this.fb.group({
            name: fb.control(this.getDefaultName(d, this.baseName), [Validators.required, noWhitespaceValidator()]),
         });
      });
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onSubmit() {
      if (this.form.valid) {
         this.submit.emit(this.form);
      }
   }

   onCloseClick() {
      this.close.emit();
      this.dialogService.close();
   }

   private getDefaultName(dashboards: Dashboard[] | null, name: string): string {
      const matches: Dashboard[] =
         dashboards?.filter((d) => d.name?.toLocaleUpperCase().trim() === name.toLocaleUpperCase().trim()) ?? [];
      if (matches.length > 0) {
         const numberSuffix: number = +name.replace(/^\D+/g, '');
         name = `${this.baseName} ${numberSuffix === 0 ? 2 : numberSuffix + 1}`;
         return this.getDefaultName(dashboards, name);
      } else {
         return name;
      }
   }
}
